<template>
  <div class="index-page">
    <h-breadcrumb :paths="paths"/>
    <!-- 道具資訊 -->
    <h-skeleton v-if="loading" class="h-mt-30 h-mb-20"/>
    <h-product
      v-else-if="spendingId"
      :image="productDetailed.imageUrl"
      :name="productDetailed.productName"
      :spending-id="spendingId"
      :coin-pay-qty="coinPayQty + $t('coinPayment.amount')"
    />
    <div class="info">
      <div v-if="coinNeedQty > 0" class="not-enough">
        {{ `${$t('notEnoughBalance')}！` }}
      </div>
      <h-user-balance :coin-need-qty="coinNeedQty"/>
      <!-- 到商城充值 -->
      <template v-if="!loading">
        <div
          v-if="coinNeedQty > 0 || !spendingId"
          class="flex-col justify-center align-center w-full"
        >
          <h-button
            block
            size="large"
            shape="round"
            to="/store"
          >
            <font-icon icon="fas fa-credit-card" />
            {{ $t('coinPayment.buyMoreHcoin') }}
          </h-button>
          <div class="my-30">
            {{ $t('or') }}
          </div>
          <h-button
            block
            size="large"
            shape="round"
            to="/redeem"
          >
            <font-icon icon="fas fa-credit-card" />
            {{ $t('coinPayment.redeemCode') }}
          </h-button>
        </div>
        <h-button
          v-else
          block
          size="large"
          shape="round"
          :disabled="overlay"
          @click="confirmBuy"
        >
          {{ $t('coinPayment.confirmBuy') + coinPayQty + $t('coinPayment.amount') }}
        </h-button>
      </template>
    </div>
    <h-loader v-if="overlay" size="lg" overlay/>
    <h-snackbar v-model="showSnackBar">
      {{ message }}
    </h-snackbar>
  </div>
</template>
<script>
import HButton from '@/components/base/HButton.vue'
import HUserBalance from '@/components/HUserBalance.vue'
import HSkeleton from '@/components/base/HSkeleton.vue'
import HLoader from '@/components/base/HLoader.vue'
import HSnackbar from '@/components/base/HSnackbar.vue'
import HBreadcrumb from '@/components/base/HBreadcrumb.vue'
import HProduct from '@/components/payment/HProduct.vue'
import { toErrorPage } from '@/utils'
import { h365PlatformApi } from '@/plugin/axios'

export default {
  name: 'indexPage',
  components: {
    HButton,
    HUserBalance,
    HSkeleton,
    HLoader,
    HSnackbar,
    HBreadcrumb,
    HProduct
  },
  data() {
    return {
      spendingId: '',
      coinPayQty: '',
      coinNeedQty: 0,
      loading: false,
      overlay: false,
      showSnackBar: false,
      message: '',
      productDetailed: {
        productName: '',
        imageUrl: ''
      }
    }
  },
  computed: {
    paths() {
      const applicationUrl = this.$cookies.get('h365_applicationUrl') || ''
      const urlHome = this.$cookies.get('h365_urlHome') || ''
      const paths = [
        ...(applicationUrl && [{
          text: this.$t('game'),
          href: applicationUrl
        }]),
        ...(urlHome && [{
          icon: 'fa-solid fa-house',
          href: urlHome
        }]),
        {
          text: this.$t('payment.purchase'),
        }
      ]
      return paths
    }
  },
  created() {
    this.spendingId = this.$route.query.paymentId
    if (this.spendingId)
      this.handleCoinDetail()
  },
  methods: {
    handleCoinDetail() {
      if (this.$store.state.coinDetail) {
        const coinDetail = this.$store.state.coinDetail
        this.setCoinDetail(coinDetail)
      }
      else
        this.getCoinDetailed()
    },
    async getCoinDetailed() {
      this.loading = true
      try {
        const url = '/coin/spending/' + this.spendingId
        const { data: response } = await h365PlatformApi.get(url)
        this.loading = false
        if (response.code === 200) {
          const res = response.data
          switch (res.status) {
          case 0:
            this.$store.commit('setCoinDetail', res)
            this.setCoinDetail(res)
            break
          case 2:
            // 订单已成功
            this.handleError('orderCompleted')
            break
          default:
            this.handleError('orderStatusNotFound')
            break
          }
        }
        else
          this.handleError('orderResponseErr')
      }
      catch(error) {
        toErrorPage(error?.code, error?.message)
      }
    },
    setCoinDetail(res) {
      this.productDetailed.productName = res.item.itemName
      this.productDetailed.imageUrl = res.item.imageUrl
      this.coinPayQty = res.coinPayQty
      this.coinNeedQty = res.coinNeedQty
    },
    handleError(errorMsg) {
      const message = this.$t(errorMsg)
      toErrorPage('Get coin detail failed', message)
    },
    async confirmBuy() {
      this.overlay = true
      try {
        const url = '/coin/orderComplete/' + this.spendingId
        const { data: response } = await h365PlatformApi.get(url)
        if (response.code !== 200) return console.error('coin spending error')
        const applicationUrl = response.data.applicationUrl
        this.$router.push({ path: '/success/confirm', query: { ...this.$route.query, applicationUrl } })
      }
      catch {
        this.showSnackBar = true
        this.message = this.$t('coinSpendingErr')
      }
      finally {
        this.overlay = false
      }
    },    
    handleImageError() {
      this.productDetailed.imageUrl = require('@/assets/image/item-default.png')
    }
  }
}
</script>
<style lang="scss" scoped>

.flex-col {
  display: flex;
  flex-direction: column;
}
.justify-center {
  justify-content: center;
}
.align-center {
  align-items: center;
}
.w-full {
  width: 100%;
}
.my-30 {
  margin: 30px 0;
}
.index-page {
  flex: 1;

  .info {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
.item-info {
  background-color: #ffffff;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 12px;
  display: flex;
  &-image {
    width: 80px;
    img {
       width: 100%;
    }
  }
  &-content {
    width: calc(100% - 80px);
    padding: 0px 12px;
    line-height: 20px;
    * {
      margin-bottom: 4px;
    }
    :last-child {
      margin-bottom: 0px;
    }
  }
  &-title {
    color: #262626;
    font-weight: bold;
  }
  &-coin {
    color: #595959;
    background: #FFFBE6;
    height: 20px;
    padding: 0px 8px;
    display: inline-flex;
  }
  &-serial-number {
    color: #595959;
  }
}
.info {  
  background-color: #ffffff;
  border-radius: 16px;
  padding: 32px;
}
.not-enough {
  color: color(black-2);
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 32px;
  text-align: center;
  width: 100%;
}
</style>